// extracted by mini-css-extract-plugin
var _1 = "ProfileUserInfoItemCardContactRowContent-modulecontactCopyButton__oy3mu";
var _2 = "ProfileUserInfoItemCardContactRowContent-modulecontactCopyWrap__UH7aM";
var _3 = "ProfileUserInfoItemCardContactRowContent-modulecontactLabel__wmMfW";
var _4 = "ProfileUserInfoItemCardContactRowContent-modulecontactRow__FBLl4";
var _5 = "ProfileUserInfoItemCardContactRowContent-modulecontactRowCopyable__gUqnQ";
var _6 = "ProfileUserInfoItemCardContactRowContent-modulecontactRowIcon__GuMla";
var _7 = "ProfileUserInfoItemCardContactRowContent-modulecontactText__X7f1G";
var _8 = "ProfileUserInfoItemCardContactRowContent-modulecontactValue__RqPJS";
export { _1 as "contactCopyButton", _2 as "contactCopyWrap", _3 as "contactLabel", _4 as "contactRow", _5 as "contactRowCopyable", _6 as "contactRowIcon", _7 as "contactText", _8 as "contactValue" }
